import React, { useState } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  Modal,
  Image,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Pagination from "@mui/material/Pagination";
import Slider from "react-slick";
import eye from "../../Assets/images/eye.svg";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import cart from "../../Assets/images/cart.png";
import inquir from "../../Assets/images/inquir.svg";
import {
  TextField,
  makeStyles,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  base_url,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import { Helmet } from "react-helmet";
import AppsIcon from "@mui/icons-material/Apps";
import ListIcon from "@mui/icons-material/List";
import Slider1 from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
// import Slider1 from '@material-ui/core/Slider';
import "rc-tooltip/assets/bootstrap.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Ringbildermenu from "../../Components/ringbildermenu";
import { isMobileOnly, isTablet } from "react-device-detect";
import ReplayIcon from "@mui/icons-material/Replay";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { store } from "../../Store/store";
import { sessionId } from "../../Reducer/homeReducer";
import ShopStyle from "../../Assets/css/RingDiamondShop.module.css";
import vline from "../../Assets/newImg/vline.png";
const { createSliderWithTooltip } = Slider1;
const Range = createSliderWithTooltip(Slider1.Range);

const highlightedStyle = {
  // backgroundColor: "yellow", // or any other highlight color
  fontWeight: "bold",
};

const secondContentDefault = () => {
  return (
    <>
      <p>
        {" "}
        With our unique blend of almost two decades of gemological expertise and
        a deep passion for crafting bespoke jewellery that resonates with your
        style, we are excited to bring your vision to life in the form of the
        most extraordinary{" "}
        <span style={highlightedStyle}>engagement rings in the UK.</span>{" "}
      </p>
    </>
  );
};
const secontContentFull = (
  <>
    <p>
      At our core, we believe that jewellery is far more than a mere accessory;
      it reflects your individuality, symbolises love, and is a cherished
      memento of the most significant moments in your life. Every piece we
      create is infused with this belief, ensuring that each{" "}
      <span style={highlightedStyle}>engagement ring</span> is not only a
      stunning work of art but also a deeply personal expression of your unique
      story. Our commitment to quality and beauty is evident in every piece of
      jewellery we design because we understand how important an engagement ring
      is as an investment. To make sure that your diamond ring meets the highest
      standard possible, we meticulously create each piece, from the initial
      design to the final polish, to ensure you receive a one-of-a-kind ring
      that offers exceptional value for your investment
    </p>

    <p>
      Our team boasts extensive experience in gemology and has dedicated years
      to mastering the intricacies of gemstones. We understand each gem's unique
      properties, from clarity to colour units. Our collection of{" "}
      <span style={highlightedStyle}>engagement rings for women</span> has been
      created with different style preferences in mind, and we use the same
      approach to design your bespoke piece. From the cut, colour, and clarity,
      we ensure you don't have to settle for anything less than the perfect
      piece of jewellery.
    </p>
  </>
);

const FirstContentDefault = () => {
  return (
    <>
      <p>
        {" "}
        Swales Diamonds is renowned for its exceptional collection of{" "}
        <span style={highlightedStyle}>
          engagement rings in Birmingham,
        </span>{" "}
        which is highly regarded for its timeless appeal and superior
        craftsmanship. Each ring in our collection is carefully crafted using
        only the highest-quality, certified diamonds. We ensure that every
        diamond ring in our collection is designed with attention to clarity,
        cut, and overall brilliance, so you get the value for your money. ...
      </p>
      {/* <p>Our range of engagement rings is diverse and budget-friendly, catering to different styles and budget preferences. From classic solitaire rings to custom pieces, from white gold to platinum, we have something for everyone. We understand that buying an engagement ring is a once-in-a-lifetime opportunity, and you want to make the most of it. That is why we only deal in quality rings that will stand the test of time. Also, we don't want you to settle for anything but the best, which is why we have such a diverse price range for our <span style={highlightedStyle}>engagement
      rings in Birmingham.</span> You can explore our readymade collection of rings or speak with our experts for a custom quote. Based on your preferences, we will be happy to design your dream ring for you in our Birmingham showroom. 
      </p> */}
    </>
  );
};
const FirstContentFull = (
  <>
    <p>
      Swales Diamonds is renowned for its exceptional collection of{" "}
      <span style={highlightedStyle}>engagement rings in Birmingham,</span>{" "}
      which is highly regarded for its timeless appeal and superior
      craftsmanship. Each ring in our collection is carefully crafted using only
      the highest-quality, certified diamonds. We ensure that every diamond ring
      in our collection is designed with attention to clarity, cut, and overall
      brilliance, so you get the value for your money.{" "}
    </p>
    <p>
      Our range of engagement rings is diverse and budget-friendly, catering to
      different styles and budget preferences. From classic solitaire rings to
      custom pieces, from white gold to platinum, we have something for
      everyone. We understand that buying an engagement ring is a
      once-in-a-lifetime opportunity, and you want to make the most of it. That
      is why we only deal in quality rings that will stand the test of time.
      Also, we don't want you to settle for anything but the best, which is why
      we have such a diverse price range for our   <span style={highlightedStyle}> engagement rings in Birmingham.</span>
      You can explore our readymade collection of rings or speak with our
      experts for a custom quote. Based on your preferences, we will be happy to
      design your dream ring for you in our Birmingham showroom.{" "}
    </p>
  </>
);


const faqData = [
  {
    id: "panel2",
    title: "How much should an engagement ring cost?",
    content:
      "The average cost of an engagement ring is about $5500, but it may vary depending on the metal, ring style, and diamond you choose. There is no one-size-fits-all when it comes to how much you should spend on an engagement ring; it all comes down to your style and budget preferences."
  },
  {
    id: "panel3",
    title: "How much should you spend on an engagement ring",
    content:  "You are expected to spend at least three months of your salary on an engagement ring, but that is not always the case anymore. For some, three months' salary is an affordable amount to spend on an engagement ring, but that is not true for everyone. So, make sure to take different aspects of your budget into consideration before making a purchase. "
  },
  {
    id: "panel4",
    title: "How to clean an engagement ring",
    content:"The upkeep of your engagement ring is in your hands, so you must clean it regularly and invest in professional cleaning every 6 months. For day-to-day cleaning, you can simply soak your engagement ring in a cleaning solution with warm water, a few drops of mild liquid soap, and baby shampoo and gently clean it with a brush. "
  },
  {
    id: "panel5",
    title: "Do men wear engagement rings",
    content:"The engagement ring, once ascertained only for the female partner, has now found its place among men's jewellery staples as well. According to a survey, around 5% of men wear engagement rings. "
  }
];
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function valuetext(value) {
  return `${value}`;
}

const RingSettings = (props) => {
  // const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const history = useHistory();
  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [view, setView] = useState(1);
  const [inquiry, setInquiry] = useState(false);
  const [quickView, setQuickView] = useState(false);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeyword, setMetaKeyWord] = useState("");
  const [listdata, setListdata] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [sortby, setSortby] = useState("");
  const [filterdata, setFilterdata] = useState([]);
  const handleCloseInquiry = () => setInquiry(false);
  const handleShowInquiry = () => setInquiry(true);
  const handleCloseQuickView = () => setQuickView(false);
  const [quickdata, setQuickdata] = React.useState([]);
  const [expanded, setExpanded] = React.useState([]);
  const [paramid, setParamid] = useState(
    props.match.params.listcategory
      ? props.match.params.listcategory
      : props.match.params.search_text
  );
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");
  const [productid, setProductid] = useState("");
  const [loader, setLoader] = useState(true);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const [shape, setShape] = useState(
    props.location.pathname?.includes("/engagement-rings/shape=")
      ? props.location.pathname?.replace("/engagement-rings/shape=", "")
      : JSON.parse(sessionStorage.getItem("bw-s_filter"))?.shape
      ? JSON.parse(sessionStorage.getItem("bw-s_filter"))?.shape
      : ""
  );
  const [metals, setMetals] = useState(
    props.location.pathname?.includes("/engagement-rings/metals=")
      ? props.location.pathname?.replace("/engagement-rings/metals=", "")
      : JSON.parse(sessionStorage.getItem("bw-s_filter"))?.metals
      ? JSON.parse(sessionStorage.getItem("bw-s_filter"))?.metals
      : ""
  );
  const [price, setPrice] = useState(
    JSON.parse(sessionStorage.getItem("bw-s_filter"))?.price
      ? JSON.parse(sessionStorage.getItem("bw-s_filter"))?.price
      : []
  );
  const [style, setStyle] = useState(
    props.location.pathname?.includes("/engagement-rings/style=")
      ? props.location.pathname?.replace("/engagement-rings/style=", "")
      : JSON.parse(sessionStorage.getItem("bw-s_filter"))?.style
      ? JSON.parse(sessionStorage.getItem("bw-s_filter"))?.style
      : ""
  );
  const [inputchange, setInputchange] = useState(false);
  const [proIndex, setProIndex] = useState("");
  const [clearFdata, setClearFdata] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.location.pathname?.includes("/engagement-rings/shape=")) {
      setShape(
        props.location.pathname?.replace("/engagement-rings/shape=", "")
      );
    } else if (props.location.pathname?.includes("/engagement-rings/metals=")) {
      setMetals(
        props.location.pathname?.replace("/engagement-rings/metals=", "")
      );
    } else if (props.location.pathname?.includes("/engagement-rings/style=")) {
      setStyle(
        props.location.pathname?.replace("/engagement-rings/style=", "")
      );
    }
  }, [props.location.pathname]);
  const clearFilter = () => {
    sessionStorage.removeItem("bw_s_filter");
    setShape("");
    setStyle("");
    setPrice([
      filterdata?.normal_filters?.price?.min,
      filterdata?.normal_filters?.price?.max,
    ]);
    setMetals("");
    setSortby(filterdata?.sort_by[0]?.value);
    setClearFdata(!clearFdata);
  };
  const submitForm = () => {
    var data = {
      product_id: productid,
      first_name,
      last_name,
      email,
      mobile: phone,
      message: comment,
    };
    axios
      .post(base_url + "/product/enquiry", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name("");
          setLast_name("");
          setEmail("");
          setComment("");
          setPhone("");
          toast.success(response.data.message, { autoClose: 3000 });
        } else {
          toast.error(response.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (props.location.pathname == "/engagement-rings/diamonds") {
      setSteps(3);
    } else if (props.location.pathname == "/engagement-rings/gemstones") {
      setSteps(4);
    } else if (props.location.pathname == "/engagement-rings/fancycolor") {
      setSteps(5);
    } else {
      setSteps(3);
    }
  }, [props.location.pathname]);

  useEffect(async () => {
    setFiltersuccess(false);
    const data = {
      currency_code: currencycode,
      diamond_id: JSON.parse(localStorage.getItem("bw-diamonddata"))?.product_id
        ? JSON.parse(localStorage.getItem("bw-diamonddata"))?.product_id
        : JSON.parse(localStorage.getItem("bw-gemstonedata"))?.product_id
        ? JSON.parse(localStorage.getItem("bw-gemstonedata"))?.product_id
        : "",
    };
    await axios
      .post(base_url + "/engagement_ring/engagement_ring_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFilterdata(res.data.data);
          setSortby(res.data.data?.sort_by[0]?.value);
          if (
            !JSON.parse(sessionStorage.getItem("bw_s_filter"))?.price?.length
          ) {
            setPrice([
              res.data.data?.normal_filters?.price?.min,
              res.data.data?.normal_filters?.price?.max,
            ]);
          }
          res.data.data?.normal_filters?.shape?.map((val) =>
            val.selected == 1 ? setShape(val.name) : ""
          );
          setFiltersuccess(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    if (filtersuccess) {
      productlist();
      setParamid(
        props.match.params.listcategory
          ? props.match.params.listcategory
          : props.match.params.search_text
      );
    }
  }, [page]);

  useEffect(() => {
    if (filtersuccess) {
      onchangesdata();
    }
  }, [shape, style, metals, inputchange, clearFdata]);

  useEffect(() => {
    if (filtersuccess) {
      productlist();
      setPage(1);
      setParamid(
        props.match.params.listcategory
          ? props.match.params.listcategory
          : props.match.params.search_text
      );
    }
  }, [
    props.match.params.listcategory,
    props.match.params.search_text,
    filtersuccess,
    sortby,
  ]);

  const productlist = async () => {
    setLoader(true);
    const data = {
      currency_code: currencycode,
      sort_by: sortby,
      style,
      matal_color: metals,
      shape,
      pricemin: price[0],
      pricemax: price[1],
      limit: 24,
      offset: (page - 1) * 24,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
    };
    await axios
      .post(base_url + "/engagement_ring/settinglist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setListdata(res.data.data?.result);
          setMetaTitle(res.data.data?.meta_title);
          setMetaDescription(res.data.data?.meta_desp);
          setMetaKeyWord(res.data.data?.meta_keywords);
          setProductCount(res.data.data?.count);
          var count = (res.data.data?.count / 24).toFixed();
          if (count * 24 >= res.data.data?.count) {
            setPageCount(count);
          } else {
            setPageCount(Number(count) + 1);
          }
          if (res.data.data?.count == 0) {
            setShowFilter(false);
          } else {
            setShowFilter(true);
          }
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          window.location.reload(true);
        } else {
          setListdata([]);
          setProductCount(0);
          setPageCount(0);
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const addtowishlist = (val, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: val.product_id,
      type: "JEWELRY",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          dispatch(whishlistlength(res.data.data.count));
          const productlist = listdata.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data.wishlist_id })
              : obj
          );
          setListdata(productlist);
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const addtocart = (product_id) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id,
      quantity: "1",
      ring_size: "",
      engraving_text: "",
      engraving_font: "",
      token: isLogin ? user.token : "",
      type: "jewelry",
    };
    axios
      .post(base_url + "/order/add_to_cart", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          dispatch(cartlengthvalue(res.data.data.total_count));
          history.push("/cart");
          toast.success(res.data.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  const quickopen = (data) => {
    setQuickdata(data);
    setQuickView(true);
  };
  const classes = useStyles();

  const sliderhandleChange = (value) => {
    setPrice(value);
  };
  const handlepriceinput = (i) => {
    var data = [];
    if (i == 0) {
      if (price[0] < filterdata?.normal_filters?.price?.min) {
        data = [filterdata?.normal_filters?.price?.min, price[1]];
      } else if (price[0] > filterdata?.normal_filters?.price?.max) {
        data = [filterdata?.normal_filters?.price?.max, price[1]];
      } else {
        data = [price[0], price[1]];
      }
    } else if (i == 1) {
      if (price[1] > filterdata?.normal_filters?.price?.max) {
        data = [price[0], filterdata?.normal_filters?.price?.max];
      } else if (price[1] < filterdata?.normal_filters?.price?.min) {
        data = [price[0], filterdata?.normal_filters?.price?.min];
      } else {
        data = [price[0], price[1]];
      }
    }
    console.log(data);
    if (data[0] < data[1]) {
      var data1 = [data[0], data[1]];
    } else {
      var data1 = [data[1], data[0]];
    }
    setPrice(data1);
    setInputchange(!inputchange);
  };

  const onchangesdata = () => {
    setPage(1);
    var data = {
      style,
      shape,
      price,
      metals,
    };
    sessionStorage.setItem("bw_s_filter", JSON.stringify(data));
    productlist();
  };
  // const [expanded, setExpanded] = React.useState(false);
  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const prev = () => {
    if (Number(page) > 1) {
      setPage(Number(page) - 1);
      window.scrollTo(0, 0);
    }
  };
  const next = () => {
    if (Number(page) < pageCount) {
      setPage(Number(page) + 1);
      window.scrollTo(0, 0);
    }
  };
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription}></meta>
        <meta name="keywords" content={metaKeyword}></meta>
        <link rel="canonical" href={window.location.href}></link>
      </Helmet>

      {/* <div className={ShopStyle.BannerTop}>
        <h3 className={ShopStyle.subTitle}>Design Your Own</h3>
        <h2 className={ShopStyle.Title}>Engagement Ring</h2>
        <ul className={ShopStyle.BreadcrumbS}>
          <li><a href='/'>Home</a></li>
          <li>/</li>
          <li>Engagement Ring</li>
        </ul>
      </div> */}
      <div className="sl_eng_pera_top_box">
        <Container>
          <Row>
            <Col>
              <div className="sl_pera_box">
                <h1>Engagement Rings Birmingham</h1>
                <LongText
                  getHighlightedDefaultText={FirstContentDefault}
                  fullText={FirstContentFull}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Ringbildermenu location="setting" />

      <div className="rcs_ringsetting_section mt-3">
        <Container fluid className="rcs_shap-wizard_container">
          <div className={ShopStyle.MainBoxRingDiamondShop}>
            <div className={ShopStyle.LeftContainer}>
              <div className={ShopStyle.titlebox}>
                <h3 className={ShopStyle.Title}>Filters</h3>
                <Button
                  variant="none"
                  onClick={clearFilter}
                  className={ShopStyle.ShowcaseClearFilter}
                >
                  <ReplayIcon /> Reset
                </Button>
              </div>

              <div
                className={
                  "rcs_filter_accordion_sec mt-3 " + ShopStyle.FilterBox
                }
              >
                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2
                      title="Diamond Shape"
                      className={
                        ShopStyle.FilterBoxTitle + " d-none d-md-block"
                      }
                    >
                      Select Style
                    </h2>
                  )}
                  <div
                    id="setting-styles"
                    className="big-ring-settings-wrap w-100 collapse show d-none d-md-block"
                  >
                    <ul
                      className={
                        "grid-topbar-elem-list big-ring-settings engListFilterStyle " +
                        ShopStyle.FilterBoxIcons
                      }
                    >
                      {!filtersuccess ? (
                        <>
                          {[...Array(8)]?.map((val) =>
                            isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={90}
                                height={92}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={140}
                                height={92}
                              />
                            )
                          )}
                        </>
                      ) : (
                        filterdata?.normal_filters?.ring_style?.map((val) => (
                          <li
                            onClick={() =>
                              style == val.value
                                ? setStyle("")
                                : setStyle(val.value)
                            }
                            className={
                              val.value == style
                                ? "rcs_ring_setting_style rcs_ring_setting_style_mobile rcs_ring_setting_style_active " +
                                  ShopStyle.active
                                : "rcs_ring_setting_style rcs_ring_setting_style_mobile"
                            }
                          >
                            <img src={val.icon} alt=""></img>
                            <span
                              className={"title--jqbwB " + ShopStyle.shapeTitle}
                              data-value="20"
                            >
                              {val.name}
                            </span>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={
                    ShopStyle.FilterBox_inner + " " + ShopStyle.engRingMetalType
                  }
                >
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2
                      title="Diamond Shape"
                      className={
                        ShopStyle.FilterBoxTitle + " d-none d-md-block"
                      }
                    >
                      Metal Type
                    </h2>
                  )}
                  <div
                    id="setting-metal-type"
                    className="collapse show big-metal-types-wrap w-100 d-none d-md-block"
                  >
                    <ul
                      className={
                        "grid-topbar-elem-list big-metal-types rcs_metal_shape " +
                        ShopStyle.FilterBoxIcons
                      }
                    >
                      {!filtersuccess ? (
                        <>
                          {[...Array(4)]?.map((val) =>
                            isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={105}
                                height={92}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={140}
                                height={92}
                              />
                            )
                          )}
                        </>
                      ) : (
                        filterdata?.normal_filters?.metal_color?.map((val) => (
                          <li
                            onClick={() =>
                              metals == val.value
                                ? setMetals("")
                                : setMetals(val.value)
                            }
                            className={
                              val.value == metals
                                ? "rcs_ring_setting_style  rcs_ring_setting_style_active " +
                                  ShopStyle.active
                                : "rcs_ring_setting_style"
                            }
                          >
                            {/* <span className="metal-type-circles all-types"> */}
                            <img
                              src={val.icon}
                              className="engList_filter_metalType"
                            ></img>
                            {/* </span> */}
                            <span
                              className={"title--jqbwB " + ShopStyle.shapeTitle}
                            >
                              {val.name}
                            </span>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2
                      title="Diamond Shape"
                      className={
                        ShopStyle.FilterBoxTitle + " d-none d-md-block"
                      }
                    >
                      Select Diamond Shape
                    </h2>
                  )}
                  <div
                    id="setting-styles"
                    className="big-ring-settings-wrap big-ring-settings-wrap1 w-100 collapse show setting-shapes d-none d-md-block "
                  >
                    <ul
                      className={
                        "grid-topbar-elem-list big-ring-settings rcs_diamond_fitler " +
                        ShopStyle.FilterBoxIcons
                      }
                    >
                      {filterdata?.normal_filters?.shape?.map((val) => (
                        <li
                          onClick={() =>
                            shape == val.value
                              ? setShape("")
                              : setShape(val.value)
                          }
                          className={
                            val.status
                              ? val.value == shape
                                ? "rcs_ring_setting_style rcs_ring_setting_style_active " +
                                  ShopStyle.active
                                : "rcs_ring_setting_style"
                              : "rcs_ring_setting_style rcs_ring_setting_style_disable"
                          }
                        >
                          <span className=" selectionIcon icon--qAfox">
                            <img
                              style={{ width: "55px" }}
                              src={val.icon}
                              alt=""
                              className="engList_filter_shape"
                            ></img>
                          </span>
                          <span
                            className={"title--jqbwB " + ShopStyle.shapeTitle}
                          >
                            {val.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  <div
                    id="setting-metal-type"
                    className="collapse show big-metal-types-wrap w-100 d-none d-md-block"
                  >
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className="mt-3"
                            width={290}
                            height={92}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className="mt-3"
                            width={435}
                            height={92}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        <div className={classes.root}>
                          <Typography id="range-slider" gutterBottom>
                            <h6 className={ShopStyle.FilterBoxTitle}>Price</h6>
                          </Typography>
                        </div>
                        <ul className="rcs_price_range_input m-0 p-0">
                          <li className="rcs_price_range_input1">
                            <i>Min</i>
                            <InputGroup className="mb-3">
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="min"
                                value={price[0]}
                                onChange={(e) =>
                                  setPrice([
                                    Number(e.target.value),
                                    Number(price[1]),
                                  ])
                                }
                                onBlurCapture={() => handlepriceinput(0)}
                              />
                            </InputGroup>
                          </li>
                          <li className="rcs_price_range_input1">
                            <i>Max</i>
                            <InputGroup className="mb-3">
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="max"
                                value={price[1]}
                                onChange={(e) =>
                                  setPrice([
                                    Number(price[0]),
                                    Number(e.target.value),
                                  ])
                                }
                                onBlurCapture={() => handlepriceinput(1)}
                              />
                            </InputGroup>
                          </li>
                        </ul>
                        <Range
                          onAfterChange={() => onchangesdata()}
                          allowCross={false}
                          min={filterdata?.normal_filters?.price?.min}
                          max={filterdata?.normal_filters?.price?.max}
                          onChange={sliderhandleChange}
                          value={price}
                          tipFormatter={(value) => `${value}`}
                        />
                      </>
                    )}
                  </div>
                </div>

                <div className="rcs_diamond_filter_section d-block d-md-none">
                  <div
                    xs={12}
                    className="rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
                  >
                    <Accordion
                      expanded={expanded === "panel3"}
                      onChange={handleChangeAccordion("panel3")}
                      className="d-md-none d-sm-block"
                    >
                      <AccordionSummary
                        className={ShopStyle.AdvaFilter}
                        style={{ width: "100%" }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <Typography>
                          <span className={ShopStyle.FilterBoxTitle}>
                            Ring Filter
                          </span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="pt-0 pb-0">
                        <Typography>
                          <div className={ShopStyle.FilterBox}>
                            <div className={ShopStyle.FilterBox_inner + " "}>
                              <h2
                                title="Diamond Shape"
                                className={ShopStyle.FilterBoxTitle}
                              >
                                Select Style
                              </h2>
                              <ul
                                className={
                                  "grid-topbar-elem-list big-ring-settings " +
                                  ShopStyle.FilterBoxIcons
                                }
                              >
                                {filterdata?.normal_filters?.ring_style?.map(
                                  (val) => (
                                    <li
                                      onClick={() =>
                                        style == val.value
                                          ? setStyle("")
                                          : setStyle(val.value)
                                      }
                                      className={
                                        val.value == style
                                          ? "rcs_ring_setting_style rcs_ring_setting_style_mobile rcs_ring_setting_style_active " +
                                            ShopStyle.active
                                          : "rcs_ring_setting_style rcs_ring_setting_style_mobile"
                                      }
                                    >
                                      <span className=" selectionIcon icon--qAfox">
                                        <img alt="" src={val.icon}></img>
                                      </span>
                                      <span
                                        className={
                                          "title--jqbwB " + ShopStyle.shapeTitle
                                        }
                                        data-value="20"
                                      >
                                        {val.name}
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>

                            <div className={ShopStyle.FilterBox_inner + " "}>
                              <h2
                                title="Diamond Shape"
                                className={ShopStyle.FilterBoxTitle}
                              >
                                Metal Type
                              </h2>
                              <ul
                                className={
                                  "grid-topbar-elem-list big-metal-types " +
                                  ShopStyle.FilterBoxIcons
                                }
                              >
                                {filterdata?.normal_filters?.metal_color?.map(
                                  (val) => (
                                    <li className="">
                                      <div
                                        onClick={() =>
                                          metals == val.value
                                            ? setMetals("")
                                            : setMetals(val.value)
                                        }
                                        className={
                                          val.value == metals
                                            ? "rcs_ring_setting_style rcs_ring_setting_style_active " +
                                              ShopStyle.active
                                            : "rcs_ring_setting_style"
                                        }
                                      >
                                        <span className="selectionIcon metal-type-circles all-types">
                                          <img alt="" src={val.icon} />
                                        </span>
                                        <span
                                          className={
                                            "title--jqbwB " +
                                            ShopStyle.shapeTitle
                                          }
                                        >
                                          {val.name}
                                        </span>
                                      </div>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>

                            <div
                              className={
                                ShopStyle.FilterBox_inner +
                                " engListFilterShape"
                              }
                            >
                              <h2
                                title="Diamond Shape"
                                className={ShopStyle.FilterBoxTitle}
                              >
                                Select Diamond Shape
                              </h2>
                              <ul
                                className={
                                  "grid-topbar-elem-list big-ring-settings rcs_diamond_fitler " +
                                  ShopStyle.FilterBoxIcons
                                }
                              >
                                {filterdata?.normal_filters?.shape?.map(
                                  (val) => (
                                    <li
                                      onClick={() =>
                                        shape == val.value
                                          ? setShape("")
                                          : setShape(val.value)
                                      }
                                      className={
                                        val.status
                                          ? val.value == shape
                                            ? "rcs_ring_setting_style rcs_ring_setting_style_active " +
                                              ShopStyle.active
                                            : "rcs_ring_setting_style"
                                          : "rcs_ring_setting_style rcs_ring_setting_style_disable"
                                      }
                                    >
                                      <span className=" selectionIcon icon--qAfox">
                                        <img
                                          style={{ width: "55px" }}
                                          src={val.icon}
                                          alt=""
                                        ></img>
                                      </span>
                                      <span
                                        className={
                                          "title--jqbwB " + ShopStyle.shapeTitle
                                        }
                                      >
                                        {val.name}
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>

                            <div className={ShopStyle.FilterBox_inner + " "}>
                              <h2
                                title="Diamond Shape"
                                className={ShopStyle.FilterBoxTitle}
                              >
                                Price
                              </h2>
                              <Range
                                min={filterdata?.normal_filters?.price?.min}
                                allowCross={false}
                                max={filterdata?.normal_filters?.price?.max}
                                onChange={sliderhandleChange}
                                value={price}
                                tipFormatter={(value) => `${value}`}
                              />
                              <Row className="">
                                <ul className="rcs_price_range_input">
                                  <li className="rcs_price_range_input1">
                                    <i>Min</i>
                                    <InputGroup className="mb-3">
                                      <InputGroup.Text>
                                        {currency}
                                      </InputGroup.Text>
                                      <FormControl
                                        aria-label="Amount (to the nearest dollar)"
                                        type="int"
                                        name="min"
                                        value={price[0]}
                                        onChange={(e) =>
                                          setPrice([
                                            Number(e.target.value),
                                            Number(price[1]),
                                          ])
                                        }
                                        onBlurCapture={() =>
                                          handlepriceinput(0)
                                        }
                                      />
                                    </InputGroup>
                                  </li>
                                  <li className="rcs_price_range_input1">
                                    <i>Max</i>
                                    <InputGroup className="mb-3">
                                      <InputGroup.Text>
                                        {currency}
                                      </InputGroup.Text>
                                      <FormControl
                                        aria-label="Amount (to the nearest dollar)"
                                        type="int"
                                        name="max"
                                        value={price[1]}
                                        onChange={(e) =>
                                          setPrice([
                                            Number(price[0]),
                                            Number(e.target.value),
                                          ])
                                        }
                                        onBlurCapture={() =>
                                          handlepriceinput(1)
                                        }
                                      />
                                    </InputGroup>
                                  </li>
                                </ul>
                              </Row>
                            </div>
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>

                    {/* <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChangeAccordion("panel4")}
                >
                  <AccordionSummary
                    style={{ width: "100%" }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <Typography>
                      <strong>Can be set with</strong>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="pt-0 pb-0">
                    <Typography>
                      <div
                        id="setting-styles"
                        className="big-ring-settings-wrap big-ring-settings-wrap1 w-100 collapse show setting-shapes"
                      >
                        <ul className="grid-topbar-elem-list big-ring-settings rcs_diamond_fitler">
                          {filterdata?.normal_filters?.shape?.map((val) => (
                            <li>
                              <div
                                onClick={() =>
                                  shape == val.value
                                    ? setShape("")
                                    : setShape(val.value)
                                }
                                className={
                                  val.status ?
                                    val.value == shape
                                      ? "rcs_ring_setting_style rcs_ring_setting_style_active"
                                      : "rcs_ring_setting_style" :
                                    "rcs_ring_setting_style rcs_ring_setting_style_disable"
                                }
                              >
                                
                                <span className=" selectionIcon icon--qAfox">
                                  <img
                                    style={{ width: "35px" }}
                                    src={val.icon}
                                  ></img>
                                </span>
                                {val.name}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion> */}
                  </div>
                </div>
              </div>
            </div>

            <div className={ShopStyle.RightContainer}>
              <div className="rcs_product_list_wrapper p-0 w-100">
                <div className={"rcs_view " + ShopStyle.TopviewProductsBox}>
                  <div
                    className={
                      "rcs_mob_filter1 rcs_ring_setting_filter " +
                      ShopStyle.TopviewProductsBoxLeft
                    }
                  >
                    {loader ? (
                      <>
                        {isMobileOnly ? (
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className="m-auto"
                            width={100}
                            height={20}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className="m-auto"
                            width={150}
                            height={20}
                          />
                        )}
                      </>
                    ) : (
                      <span>{productCount} product(s) found </span>
                    )}
                  </div>
                  <div className={ShopStyle.TopviewProductsBoxRight}>
                    <div
                      className={
                        "rcs_mob_filter1 rcs_ring_setting_filter1 " +
                        ShopStyle.TopviewProductsviewIcon
                      }
                    >
                      <span className={ShopStyle.TopviewProductsBoxtitle}>
                        {" "}
                        View
                      </span>
                      {/* <AppsIcon
                        className={view == 1 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(1)}
                      /> */}

                      <svg
                        className={view == 1 ? "active_grid" : " "}
                        onClick={() => setView(1)}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 0H8.57143V8.57143H0V0ZM11.4286 0H20V8.57143H11.4286V0ZM8.57143 11.4286H0V20H8.57143V11.4286ZM11.4286 11.4286H20V20H11.4286V11.4286Z"
                          fill="none"
                        />
                      </svg>

                      <span style={{ borderRight: "1px solid #ccc" }}></span>
                      {/* <ListIcon
                        className={view == 2 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(2)}
                      /> */}

                      <svg
                        className={view == 2 ? "active_grid" : " "}
                        onClick={() => setView(2)}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 0H4V4H0V0ZM6.00028 0H20.0003V4H6.00028V0ZM4 8.00014H0V12.0001H4V8.00014ZM0 16.0003H4V20.0003H0V16.0003ZM20.0003 8.00014H6.00028V12.0001H20.0003V8.00014ZM6.00028 16.0003H20.0003V20.0003H6.00028V16.0003Z"
                          fill="none"
                        />
                      </svg>

                      {/* <ul>                                                
                                                <li><AppsIcon className={view == 1 ? "active_grid" : ""} onClick={() => setView(1)} /></li>
                                                <li><span></span></li>
                                                <li><ListIcon className={view == 2 ? "active_grid" : ""} onClick={() => setView(2)} /></li>
                                            </ul> */}
                    </div>
                    <img
                      src={vline}
                      alt=""
                      className={ShopStyle.TopviewProductsVline}
                    />
                    <div className="rcs_sorting">
                      {/* <div className="rcs_sorting_title text-left">
                        <span
                          onClick={() => prev()}
                          className="prev"
                          style={{ opacity: page > 1 ? "1" : "0.2" }}
                        >
                          <ArrowBackIosIcon /> Previous
                        </span>
                      </div> */}

                      <div
                        className={
                          "rcs_sort_filter p-0 " +
                          ShopStyle.TopviewProductsshortBy
                        }
                      >
                        <label>
                          <span
                            className={ShopStyle.TopviewProductsshortByTitle}
                          >
                            Sort By
                            {/* <i>Featured</i> */}
                          </span>
                        </label>
                        <Form.Select
                          onChange={(e) => {
                            setSortby(e.target.value);
                            window.scrollTo(0, 0);
                          }}
                          value={sortby}
                          aria-label="Default select example"
                        >
                          {filterdata?.sort_by?.map((val) => (
                            <option value={val.value}>{val.name}</option>
                          ))}
                        </Form.Select>
                      </div>

                      {/* <div className="rcs_sorting_title text-right">
                        
                        <span
                          onClick={() => next()}
                          className="prev"
                          style={{ opacity: page < pageCount ? "1" : "0.2" }}
                        >
                          Next <ArrowForwardIosIcon />
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {isMobileOnly ? (
                <div className="rcs_product_list_wrapper p-0 w-100">
                  {view == 1 ? (
                    <div className="rcs_product_grid">
                      <Row>
                        {listdata?.map((val, index) => (
                          <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                            <div className="rcs_product_item position-relative">
                              {loader ? (
                                <div className="rcs_filter_prod_wrapper">
                                  <CircularProgress className="rcs_filter_prod_loader" />
                                </div>
                              ) : (
                                ""
                              )}
                              <div class="d-flex  hover-buttons justify-content-between">
                                {val.enable_ecommerce == "1" ? (
                                  <span
                                    onClick={() => addtocart(val.product_id)}
                                  >
                                    <img src={cart} />
                                  </span>
                                ) : (
                                  <span
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    <img src={inquir} />
                                  </span>
                                )}
                                {/* {val.enable_ecommerce == "1" ? <span onClick={() => addtocart(val.product_id)}> <img src={cart} /> </span> : <span onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </span>} */}
                                <span onClick={() => quickopen(val)}>
                                  <Image src={eye} />
                                </span>
                              </div>
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex("")}
                                to={"/ringsettingdetail/setting/" + val.slug}
                              >
                                {/* <div class="d-flex  hover-buttons justify-content-between">
                                                        {val.enable_ecommerce == "1" ? <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button> : <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button>}
                                                        <Button> <img src={eye} />  </Button>
                                                    </div> */}
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>
                                      {proIndex == index + 1 ? (
                                        <img
                                          className="img-fluid"
                                          src={val.product_image[1].url}
                                        />
                                      ) : (
                                        <img
                                          className="img-fluid"
                                          src={val.product_image[0].url}
                                        />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <img src={val.product_image[0].url}></img>
                                )}
                              </NavLink>
                              <div className="rcs_prod_info">
                                <div className="d-flex align-items-start pt-10 justify-content-center">
                                  <h2
                                    onClick={() => {
                                      history.push(
                                        "/ringsettingdetail/setting/" + val.slug
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                    className="rcs_list_title"
                                  >
                                    {val.name}
                                  </h2>
                                  <button class="rcs_wish_btn rcs_wish_btn_desktop">
                                    {val.is_wishlist == "0" ? (
                                      <FavoriteBorderIcon
                                        onClick={() =>
                                          addtowishlist(val, index)
                                        }
                                      />
                                    ) : (
                                      <FavoriteIcon
                                        onClick={() =>
                                          addtowishlist(val, index)
                                        }
                                        className="animate__animated animate__heartBeat"
                                      />
                                    )}
                                  </button>
                                </div>
                                <p className="rcs_emailprice">
                                  {val.is_price !== "0"
                                    ? val.currency_icon + val.sale_price
                                    : "Email us for Price"}
                                </p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ) : (
                    listdata?.map((val, index) => (
                      <div className="rcs_prodlist_item">
                        <Row>
                          <Col className="mg_nopad" xs={5} sm={5} md={4}>
                            <div className="rcs_product_item rcs_list_img">
                              <button class="rcs_wish_btn">
                                {val.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() => addtowishlist(val, index)}
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() => addtowishlist(val, index)}
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </button>
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex("")}
                                to={"/ringsettingdetail/setting/" + val.slug}
                              >
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>
                                      {proIndex == index + 1 ? (
                                        <img src={val.product_image[1].url} />
                                      ) : (
                                        <img src={val.product_image[0].url} />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <img src={val.product_image[0].url}></img>
                                )}
                              </NavLink>
                            </div>
                          </Col>
                          <Col className="mg_nopad" xs={7} sm={7} md={8}>
                            <div className="rcs_prod_list_info">
                              <div className="d-flex align-items-start pt-10">
                                <h2 className="rcs_list_title">{val.name}</h2>
                              </div>
                              {val.is_price !== "0" ? (
                                <p className="rcs_main_price">
                                  {val.currency_icon}
                                  {val.sale_price}
                                </p>
                              ) : (
                                <p className="rcs_list_email">
                                  Email us for Price
                                </p>
                              )}
                              <div className="rcs_dblock">
                                {val.enable_ecommerce == "1" ? (
                                  <Button
                                    onClick={() => addtocart(val.product_id)}
                                  >
                                    <img src={cart} /> ADD TO CART
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    <img src={inquir} /> INQUIRE
                                  </Button>
                                )}
                                <Button onClick={() => quickopen(val)}>
                                  <img src={eye} /> QUICK VIEW
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}
                  {/* product list pagination */}
                  {pageCount > 1 ? (
                    <Row className="mt-5 mb-3">
                      <Col xs={1} className="p-0">
                        <div className="rcs_sorting_title">
                          <span
                            onClick={() => prev()}
                            className="prev"
                            style={{ opacity: page > 1 ? "1" : "0.2" }}
                          >
                            <ArrowBackIosIcon /> Previous
                          </span>
                        </div>
                      </Col>
                      <Col xs={10} className="p-0">
                        <div className="rcs_pagination">
                          <Pagination
                            count={pageCount}
                            page={page}
                            onChange={handlePageChange}
                          />
                        </div>
                      </Col>
                      <Col xs={1} className="p-0">
                        <div className="rcs_sorting_title text-right">
                          <span
                            onClick={() => next()}
                            className="prev"
                            style={{
                              opacity: page < pageCount ? "1" : "0.2",
                            }}
                          >
                            Next <ArrowForwardIosIcon />
                          </span>
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
              ) : isTablet ? (
                <div className="rcs_product_list_wrapper p-0 w-100">
                  {view == 1 ? (
                    <div className="rcs_product_grid">
                      <Row>
                        {listdata?.map((val, index) => (
                          <Col xs={6} sm={6} md={4} lg={4} xl={3}>
                            <div className="rcs_product_item position-relative">
                              {loader ? (
                                <div className="rcs_filter_prod_wrapper">
                                  <CircularProgress className="rcs_filter_prod_loader" />
                                </div>
                              ) : (
                                ""
                              )}
                              <div class="d-flex  hover-buttons justify-content-between">
                                {val.enable_ecommerce == "1" ? (
                                  <span
                                    onClick={() => addtocart(val.product_id)}
                                  >
                                    <img src={cart} />
                                  </span>
                                ) : (
                                  <span
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    <img src={inquir} />
                                  </span>
                                )}
                                {/* {val.enable_ecommerce == "1" ? <span onClick={() => addtocart(val.product_id)}> <img src={cart} /> </span> : <span onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </span>} */}
                                <span onClick={() => quickopen(val)}>
                                  <Image src={eye} />
                                </span>
                              </div>
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex("")}
                                to={"/ringsettingdetail/setting/" + val.slug}
                              >
                                {/* <div class="d-flex  hover-buttons justify-content-between">
                                                                {val.enable_ecommerce == "1" ? <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button> : <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button>}
                                                                <Button> <img src={eye} />  </Button>
                                                            </div> */}
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>
                                      {proIndex == index + 1 ? (
                                        <img src={val.product_image[1].url} />
                                      ) : (
                                        <img src={val.product_image[0].url} />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <img src={val.product_image[0].url}></img>
                                )}
                              </NavLink>
                              <div className="rcs_prod_info">
                                <div className="d-flex align-items-start pt-10">
                                  <h2
                                    onClick={() => {
                                      history.push(
                                        "/ringsettingdetail/setting/" + val.slug
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                    className="rcs_list_title"
                                  >
                                    {val.name}
                                  </h2>
                                  <button class="rcs_wish_btn rcs_wish_btn_desktop">
                                    {val.is_wishlist == "0" ? (
                                      <FavoriteBorderIcon
                                        onClick={() =>
                                          addtowishlist(val, index)
                                        }
                                      />
                                    ) : (
                                      <FavoriteIcon
                                        onClick={() =>
                                          addtowishlist(val, index)
                                        }
                                        className="animate__animated animate__heartBeat"
                                      />
                                    )}
                                  </button>
                                </div>
                                <p className="rcs_emailprice">
                                  {val.is_price !== "0"
                                    ? val.currency_icon + val.sale_price
                                    : "Email us for Price"}
                                </p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ) : (
                    listdata?.map((val, index) => (
                      <div className="rcs_prodlist_item">
                        <Row>
                          <Col className="mg_nopad" xs={5} sm={5} md={4}>
                            <div className="rcs_product_item rcs_list_img">
                              <button class="rcs_wish_btn">
                                {val.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() => addtowishlist(val, index)}
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() => addtowishlist(val, index)}
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </button>
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex("")}
                                to={"/ringsettingdetail/setting/" + val.slug}
                              >
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>
                                      {proIndex == index + 1 ? (
                                        <img src={val.product_image[1].url} />
                                      ) : (
                                        <img src={val.product_image[0].url} />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <img src={val.product_image[0].url}></img>
                                )}
                              </NavLink>
                            </div>
                          </Col>
                          <Col className="mg_nopad" xs={7} sm={7} md={8}>
                            <div className="rcs_prod_list_info">
                              <div className="d-flex align-items-start pt-10">
                                <h2 className="rcs_list_title">{val.name}</h2>
                              </div>
                              {val.is_price !== "0" ? (
                                <p className="rcs_main_price">
                                  {val.currency_icon}
                                  {val.sale_price}
                                </p>
                              ) : (
                                <p className="rcs_list_email">
                                  Email us for Price
                                </p>
                              )}
                              <div className="rcs_dblock">
                                {val.enable_ecommerce == "1" ? (
                                  <Button
                                    onClick={() => addtocart(val.product_id)}
                                  >
                                    <img src={cart} /> ADD TO CART
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    <img src={inquir} /> INQUIRE
                                  </Button>
                                )}
                                <Button onClick={() => quickopen(val)}>
                                  <img src={eye} /> QUICK VIEW
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}
                  {/* product list pagination */}
                  {pageCount > 1 ? (
                    <Row className="mt-5 mb-3">
                      <Col xs={2} className="pr-0">
                        <div className="rcs_sorting_title">
                          <span
                            onClick={() => prev()}
                            className="prev"
                            style={{ opacity: page > 1 ? "1" : "0.2" }}
                          >
                            <ArrowBackIosIcon /> Previous
                          </span>
                        </div>
                      </Col>
                      <Col xs={8} className="p-0">
                        <div className="rcs_pagination">
                          <Pagination
                            count={pageCount}
                            page={page}
                            onChange={handlePageChange}
                          />
                        </div>
                      </Col>
                      <Col xs={2} className="pl-0">
                        <div className="rcs_sorting_title text-right">
                          <span
                            onClick={() => next()}
                            className="prev"
                            style={{
                              opacity: page < pageCount ? "1" : "0.2",
                            }}
                          >
                            Next <ArrowForwardIosIcon />
                          </span>
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
              ) : (
                <Container className="rcs_shap-wizard_container">
                  <Row className="w-100 m-auto">
                    <Col xs={12}>
                      <div className="rcs_product_list_wrapper p-0 w-100">
                        {view == 1 ? (
                          <div className="rcs_product_grid">
                            <Row>
                              {listdata?.map((val, index) => (
                                <Col
                                  xs={6}
                                  sm={6}
                                  md={4}
                                  lg={4}
                                  xl={4}
                                  className={ShopStyle.Col_box}
                                >
                                  <div className="rcs_product_item position-relative">
                                    {loader ? (
                                      <div className="rcs_filter_prod_wrapper">
                                        <CircularProgress className="rcs_filter_prod_loader" />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {/* <div class=" hover-buttons">
                                      {val.enable_ecommerce == "1" ? (
                                        <span
                                          onClick={() => addtocart(val.product_id)}
                                        >

                                          <img src={cart} />
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() => {
                                            setProductid(val.product_id);
                                            handleShowInquiry(true);
                                          }}
                                        >

                                          <img src={inquir} />
                                        </span>
                                      )}
                                      {val.enable_ecommerce == "1" ? <span onClick={() => addtocart(val.product_id)}> <img src={cart} /> </span> : <span onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </span>}
                                      <span onClick={() => quickopen(val)}>

                                        <Image src={eye} />
                                      </span>
                                    </div> */}

                                    <NavLink
                                      onMouseOver={() => {
                                        setProIndex(index + 1);
                                        console.log(proIndex);
                                      }}
                                      onMouseLeave={() => setProIndex("")}
                                      to={
                                        "/ringsettingdetail/setting/" + val.slug
                                      }
                                    >
                                      {/* <div class="d-flex  hover-buttons justify-content-between">
                                                                {val.enable_ecommerce == "1" ? <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button> : <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button>}
                                                                <Button> <img src={eye} />  </Button>
                                                            </div> */}
                                      {/* <div class="color-overlay"></div> */}
                                      {val.product_image?.length > 1 ? (
                                        <>
                                          <div>
                                            {proIndex == index + 1 ? (
                                              <img
                                                src={val.product_image[1].url}
                                              />
                                            ) : (
                                              <img
                                                src={val.product_image[0].url}
                                              />
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <img
                                          src={val.product_image[0].url}
                                        ></img>
                                      )}
                                    </NavLink>
                                    <div
                                      className={
                                        ShopStyle.HoverBoxIcons +
                                        " ringSettingHoverBox"
                                      }
                                    >
                                      <div
                                        className={
                                          ShopStyle.HoverBoxWishlist +
                                          " ringSettingHoverBoxWishlist"
                                        }
                                      >
                                        {val.is_wishlist == "0" ? (
                                          <svg
                                            onClick={() =>
                                              addtowishlist(val, index)
                                            }
                                            className={
                                              ShopStyle.HoverBoxWishlist11
                                            }
                                            width="86"
                                            height="86"
                                            viewBox="0 0 86 86"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g filter="url(#filter0_d_1_256)">
                                              <circle
                                                cx="43"
                                                cy="43"
                                                r="23"
                                                fill="white"
                                              />
                                            </g>
                                            <path
                                              d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z"
                                              stroke="#14344A"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <defs>
                                              <filter
                                                id="filter0_d_1_256"
                                                x="0"
                                                y="0"
                                                width="86"
                                                height="86"
                                                filterUnits="userSpaceOnUse"
                                                color-interpolation-filters="sRGB"
                                              >
                                                <feFlood
                                                  flood-opacity="0"
                                                  result="BackgroundImageFix"
                                                />
                                                <feColorMatrix
                                                  in="SourceAlpha"
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  result="hardAlpha"
                                                />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite
                                                  in2="hardAlpha"
                                                  operator="out"
                                                />
                                                <feColorMatrix
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in2="BackgroundImageFix"
                                                  result="effect1_dropShadow_1_256"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in="SourceGraphic"
                                                  in2="effect1_dropShadow_1_256"
                                                  result="shape"
                                                />
                                              </filter>
                                            </defs>
                                          </svg>
                                        ) : (
                                          <svg
                                            onClick={() =>
                                              addtowishlist(val, index)
                                            }
                                            className={
                                              ShopStyle.HoverBoxWishlist21
                                            }
                                            width="86"
                                            height="86"
                                            viewBox="0 0 86 86"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g filter="url(#filter0_d_1_259)">
                                              <circle
                                                cx="43"
                                                cy="43"
                                                r="23"
                                                fill="#607980"
                                              />
                                            </g>
                                            <path
                                              d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z"
                                              fill="white"
                                            />
                                            <defs>
                                              <filter
                                                id="filter0_d_1_259"
                                                x="0"
                                                y="0"
                                                width="86"
                                                height="86"
                                                filterUnits="userSpaceOnUse"
                                                color-interpolation-filters="sRGB"
                                              >
                                                <feFlood
                                                  flood-opacity="0"
                                                  result="BackgroundImageFix"
                                                />
                                                <feColorMatrix
                                                  in="SourceAlpha"
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  result="hardAlpha"
                                                />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite
                                                  in2="hardAlpha"
                                                  operator="out"
                                                />
                                                <feColorMatrix
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in2="BackgroundImageFix"
                                                  result="effect1_dropShadow_1_259"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in="SourceGraphic"
                                                  in2="effect1_dropShadow_1_259"
                                                  result="shape"
                                                />
                                              </filter>
                                            </defs>
                                          </svg>
                                        )}
                                      </div>
                                      <div
                                        className={
                                          ShopStyle.HoverBoxWishlist +
                                          " ringSettingHoverBoxWishlist"
                                        }
                                      >
                                        <svg
                                          onClick={() => quickopen(val)}
                                          className={
                                            ShopStyle.HoverBoxWishlist1
                                          }
                                          width="86"
                                          height="86"
                                          viewBox="0 0 86 86"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g filter="url(#filter0_d_1_251)">
                                            <circle
                                              cx="43"
                                              cy="43"
                                              r="23"
                                              fill="white"
                                            />
                                          </g>
                                          <path
                                            d="M54.9088 42.582C52.9428 38.311 48.4998 34 42.9998 34C37.4998 34 33.0568 38.311 31.0908 42.582C31.0309 42.7132 31 42.8558 31 43C31 43.1442 31.0309 43.2868 31.0908 43.418C33.0568 47.689 37.4998 52 42.9998 52C48.4998 52 52.9428 47.689 54.9088 43.418C54.9686 43.2868 54.9995 43.1442 54.9995 43C54.9995 42.8558 54.9686 42.7132 54.9088 42.582V42.582ZM42.9998 50C38.5888 50 34.8538 46.448 33.1098 43C34.8538 39.552 38.5888 36 42.9998 36C47.4108 36 51.1458 39.552 52.8898 43C51.1458 46.448 47.4108 50 42.9998 50Z"
                                            fill="#607980"
                                          />
                                          <path
                                            d="M42.9998 38C42.0109 38 41.0442 38.2932 40.2219 38.8427C39.3997 39.3921 38.7588 40.173 38.3804 41.0866C38.0019 42.0002 37.9029 43.0055 38.0958 43.9755C38.2888 44.9454 38.765 45.8363 39.4642 46.5355C40.1635 47.2348 41.0544 47.711 42.0243 47.9039C42.9942 48.0969 43.9995 47.9978 44.9132 47.6194C45.8268 47.241 46.6077 46.6001 47.1571 45.7779C47.7065 44.9556 47.9998 43.9889 47.9998 43C47.9982 41.6744 47.4709 40.4036 46.5335 39.4662C45.5962 38.5289 44.3254 38.0016 42.9998 38V38ZM42.9998 46C42.4064 46 41.8264 45.8241 41.333 45.4944C40.8397 45.1648 40.4552 44.6962 40.2281 44.1481C40.0011 43.5999 39.9416 42.9967 40.0574 42.4147C40.1732 41.8328 40.4589 41.2982 40.8784 40.8787C41.298 40.4591 41.8325 40.1734 42.4145 40.0576C42.9964 39.9419 43.5996 40.0013 44.1478 40.2284C44.696 40.4554 45.1645 40.8399 45.4942 41.3333C45.8238 41.8266 45.9998 42.4067 45.9998 43C45.9998 43.7956 45.6837 44.5587 45.1211 45.1213C44.5585 45.6839 43.7954 46 42.9998 46Z"
                                            fill="#607980"
                                          />
                                          <defs>
                                            <filter
                                              id="filter0_d_1_251"
                                              x="0"
                                              y="0"
                                              width="86"
                                              height="86"
                                              filterUnits="userSpaceOnUse"
                                              color-interpolation-filters="sRGB"
                                            >
                                              <feFlood
                                                flood-opacity="0"
                                                result="BackgroundImageFix"
                                              />
                                              <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                              />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite
                                                in2="hardAlpha"
                                                operator="out"
                                              />
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in2="BackgroundImageFix"
                                                result="effect1_dropShadow_1_251"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="effect1_dropShadow_1_251"
                                                result="shape"
                                              />
                                            </filter>
                                          </defs>
                                        </svg>
                                        <svg
                                          onClick={() => quickopen(val)}
                                          className={
                                            ShopStyle.HoverBoxWishlist2
                                          }
                                          width="86"
                                          height="86"
                                          viewBox="0 0 86 86"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g filter="url(#filter0_d_1_262)">
                                            <circle
                                              cx="43"
                                              cy="43"
                                              r="23"
                                              fill="#607980"
                                            />
                                          </g>
                                          <path
                                            d="M54.91 42.58C52.94 38.31 48.5 34 43 34C37.5 34 33.06 38.31 31.09 42.58C31.0307 42.7121 31 42.8552 31 43C31 43.1448 31.0307 43.2879 31.09 43.42C33.06 47.69 37.5 52 43 52C48.5 52 52.94 47.69 54.91 43.42C54.9693 43.2879 55 43.1448 55 43C55 42.8552 54.9693 42.7121 54.91 42.58V42.58ZM43 48C42.0111 48 41.0444 47.7068 40.2221 47.1573C39.3999 46.6079 38.759 45.827 38.3806 44.9134C38.0022 43.9998 37.9031 42.9945 38.0961 42.0245C38.289 41.0546 38.7652 40.1637 39.4645 39.4645C40.1637 38.7652 41.0546 38.289 42.0245 38.0961C42.9945 37.9031 43.9998 38.0022 44.9134 38.3806C45.827 38.759 46.6079 39.3999 47.1573 40.2221C47.7068 41.0444 48 42.0111 48 43C47.9984 44.3256 47.4711 45.5964 46.5338 46.5338C45.5964 47.4711 44.3256 47.9984 43 48V48Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M43 46C44.6569 46 46 44.6569 46 43C46 41.3431 44.6569 40 43 40C41.3431 40 40 41.3431 40 43C40 44.6569 41.3431 46 43 46Z"
                                            fill="white"
                                          />
                                          <defs>
                                            <filter
                                              id="filter0_d_1_262"
                                              x="0"
                                              y="0"
                                              width="86"
                                              height="86"
                                              filterUnits="userSpaceOnUse"
                                              color-interpolation-filters="sRGB"
                                            >
                                              <feFlood
                                                flood-opacity="0"
                                                result="BackgroundImageFix"
                                              />
                                              <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                              />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite
                                                in2="hardAlpha"
                                                operator="out"
                                              />
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in2="BackgroundImageFix"
                                                result="effect1_dropShadow_1_262"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="effect1_dropShadow_1_262"
                                                result="shape"
                                              />
                                            </filter>
                                          </defs>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className="rcs_prod_info">
                                      <h2
                                        onClick={() => {
                                          history.push(
                                            "/ringsettingdetail/setting/" +
                                              val.slug
                                          );
                                          window.scrollTo(0, 0);
                                        }}
                                        className="rcs_list_title"
                                      >
                                        {val.name}
                                      </h2>
                                      {/* <button class="rcs_wish_btn rcs_wish_btn_desktop">
                                          {val.is_wishlist == "0" ? (
                                            <FavoriteBorderIcon
                                              onClick={() =>
                                                addtowishlist(val, index)
                                              }
                                            />
                                          ) : (
                                            <FavoriteIcon
                                              onClick={() =>
                                                addtowishlist(val, index)
                                              }
                                              className="animate__animated animate__heartBeat"
                                            />
                                          )}
                                        </button> */}
                                      <p className="rcs_emailprice">
                                        {val.is_price !== "0"
                                          ? val.currency_icon + val.sale_price
                                          : "Email us for Price"}
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        ) : (
                          listdata?.map((val, index) => (
                            <div className="rcs_prodlist_item">
                              <Row>
                                <Col className="mg_nopad" xs={5} sm={5} md={4}>
                                  <div className="rcs_product_item rcs_list_img">
                                    <button class="rcs_wish_btn">
                                      {val.is_wishlist == "0" ? (
                                        <FavoriteBorderIcon
                                          onClick={() =>
                                            addtowishlist(val, index)
                                          }
                                        />
                                      ) : (
                                        <FavoriteIcon
                                          onClick={() =>
                                            addtowishlist(val, index)
                                          }
                                          className="animate__animated animate__heartBeat"
                                        />
                                      )}
                                    </button>
                                    <NavLink
                                      onMouseOver={() => {
                                        setProIndex(index + 1);
                                        console.log(proIndex);
                                      }}
                                      onMouseLeave={() => setProIndex("")}
                                      to={
                                        "/ringsettingdetail/setting/" + val.slug
                                      }
                                    >
                                      <div class="color-overlay"></div>
                                      {val.product_image?.length > 1 ? (
                                        <>
                                          <div>
                                            {proIndex == index + 1 ? (
                                              <img
                                                src={val.product_image[1].url}
                                              />
                                            ) : (
                                              <img
                                                src={val.product_image[0].url}
                                              />
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <img
                                          src={val.product_image[0].url}
                                        ></img>
                                      )}
                                    </NavLink>
                                  </div>
                                </Col>
                                <Col className="mg_nopad" xs={7} sm={7} md={8}>
                                  <div className="rcs_prod_list_info">
                                    <div className="d-flex align-items-start pt-10">
                                      <h2 className="rcs_list_title">
                                        {val.name}
                                      </h2>
                                    </div>
                                    {val.is_price !== "0" ? (
                                      <p className="rcs_main_price">
                                        {val.currency_icon}
                                        {val.sale_price}
                                      </p>
                                    ) : (
                                      <p className="rcs_list_email">
                                        Email us for Price
                                      </p>
                                    )}
                                    <div className="rcs_dblock">
                                      {val.enable_ecommerce == "1" ? (
                                        <Button
                                          onClick={() =>
                                            addtocart(val.product_id)
                                          }
                                        >
                                          <img src={cart} /> ADD TO CART
                                        </Button>
                                      ) : (
                                        <Button
                                          onClick={() => {
                                            setProductid(val.product_id);
                                            handleShowInquiry(true);
                                          }}
                                        >
                                          <img src={inquir} /> INQUIRE
                                        </Button>
                                      )}
                                      <Button onClick={() => quickopen(val)}>
                                        <img src={eye} /> QUICK VIEW
                                      </Button>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          ))
                        )}
                        {/* product list pagination */}
                        {pageCount > 1 ? (
                          <Row className="mt-5 mb-5">
                            <Col xs={12} lg={2} className="pr-0">
                              <div className="rcs_sorting_title">
                                <span
                                  onClick={() => prev()}
                                  className="prev"
                                  style={{ opacity: page > 1 ? "1" : "0.2" }}
                                >
                                  <ArrowBackIosIcon /> Previous
                                </span>
                              </div>
                            </Col>
                            <Col xs={12} lg={8} className="p-0">
                              <div className="rcs_pagination">
                                <Pagination
                                  count={pageCount}
                                  page={page}
                                  onChange={handlePageChange}
                                />
                              </div>
                            </Col>
                            <Col xs={12} lg={2} className="pl-0">
                              <div className="rcs_sorting_title text-right">
                                <span
                                  onClick={() => next()}
                                  className="prev"
                                  style={{
                                    opacity: page < pageCount ? "1" : "0.2",
                                  }}
                                >
                                  Next <ArrowForwardIosIcon />
                                </span>
                              </div>
                            </Col>
                          </Row>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </Container>
              )}
            </div>
          </div>

          {/* <Row className="w-100 d-block m-auto">
            <Col xs={12} className=" mt-4 mb-5">
              <div className="rcs_diamond_content">
                <h1>ENGAGEMENT RINGS</h1>
                <Col xs={12} sm={12} md={{ span: 8, offset: 2 }}>
                  <p>
                    Engagement rings are the ultimate expression of love, which
                    is why their design requires a personal touch. It’s easy to
                    design the engagement ring of your dreams, down to the last
                    detail. Choose lovingly handcrafted engagement rings in a
                    range of popular styles. Browse loose diamonds for the
                    perfect center stone to complete your engagement setting.
                    Then, sit back and admire your beautiful creation!
                  </p>
                </Col>
              </div>
            </Col>
          </Row> */}
        </Container>
      </div>
      {/*Inquiry Modal*/}
      <Modal show={inquiry} onHide={handleCloseInquiry}>
        <Modal.Header>
          <Modal.Title>PRODUCT INQUIRY</Modal.Title>
          <button type="button" onClick={handleCloseInquiry} class="close">
            <span aria-hidden="true">×</span>
            <span class="sr-only">Close</span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="rcs_add_address">
            <Row>
              <Col>
                <p>
                  Our friendly staff will be happy to help you with whatever
                  questions you may have about this item.
                </p>
              </Col>
            </Row>
            <Form>
              <Row>
                <Col xs={12} sm={6} className="rcs_custom_padding">
                  <TextField
                    id="outlined-basic"
                    label="First Name"
                    type="text"
                    variant="outlined"
                    value={first_name}
                    onChange={(e) => setFirst_name(e.target.value)}
                    required
                  />
                </Col>
                <Col xs={12} sm={6} className="rcs_custom_padding">
                  <TextField
                    id="outlined-basic"
                    label="Last Name"
                    type="text"
                    variant="outlined"
                    value={last_name}
                    onChange={(e) => setLast_name(e.target.value)}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} className="rcs_custom_padding">
                  <TextField
                    id="outlined-basic"
                    label="Email Address"
                    type="Email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Col>
                <Col xs={12} sm={6} className="rcs_custom_padding">
                  <TextField
                    id="outlined-basic"
                    label="Phone Number"
                    type="number"
                    variant="outlined"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="rcs_custom_padding">
                  <TextField
                    id="outlined-basic"
                    multiline
                    rows={4}
                    label="Your Message"
                    type="text"
                    variant="outlined"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    required
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="rcs_cancel_button mr-2"
            onClick={handleCloseInquiry}
          >
            Close
          </Button>
          <Button
            variant="primary"
            className="rcs_save_button"
            onClick={submitForm}
          >
            Submit Inquiry
          </Button>
        </Modal.Footer>
      </Modal>
      {/*Inquiry Modal*/}
      {/*QuickView Modal*/}
      {quickdata?.name?.length ? (
        <Modal
          show={quickView}
          className="rcs_quick_modal"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={handleCloseQuickView}
        >
          <Modal.Header>
            <button type="button" onClick={handleCloseQuickView} class="close">
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="rcs_quick_view">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={6}>
                  <img src={quickdata?.product_image[0]?.url}></img>
                </Col>
                <Col xs={12} sm={6}>
                  <div className="rcs_prod_info">
                    <div className="d-flex align-items-start pt-10">
                      <h2 className="rcs_list_title">{quickdata?.name}</h2>

                      {/* <button class="rcs_wish_btn rcs_wish_btn_desktop">{quickdata?.is_wishlist == "0" ? <FavoriteBorderIcon onClick={() => addtowishlist(quickdata[0])} /> : <FavoriteIcon onClick={() => addtowishlist(quickdata[0])} />}</button> */}
                    </div>
                    <Divider />
                    <p className="rcs_emailprice">
                      <strong>SKU :</strong>
                      {quickdata?.sku}
                    </p>
                    <Divider />
                    <p className="rcs_emailprice">
                      {quickdata?.is_price !== "0"
                        ? quickdata?.currency_icon + quickdata?.sale_price
                        : "Email us for Price"}
                    </p>
                    <Divider />
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" className="rcs_cancel_button mr-2">
                            <MailOutlineIcon className='mr-2' /> Email
                        </Button> */}
            <Button
              variant="secondary"
              className="rcs_cancel_button mr-2"
              onClick={() => {
                addtocart(quickdata?.product_id);
                window.scrollTo(0, 0);
              }}
            >
              <Image src={cart} className="mr-2" style={{ width: "20px" }} />
              Add to Cart
            </Button>
            <Button
              variant="secondary"
              className="rcs_cancel_button"
              onClick={() => {
                history.push("/ringsettingdetail/setting/" + quickdata?.slug);
                window.scrollTo(0, 0);
              }}
            >
              <ListIcon className="mr-2" /> Details
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        ""
      )}

      <>
        <Container className="">
          <Row>
            <Col>
              <div className="sl_pera_box fAq_eng_Accordian_section text-left">
                {/* <h2>Shop Diamond Engagement Rings at Swales Diamonds</h2>
                <LongText
                  getHighlightedDefaultText={secondContentDefault}
                  fullText={secontContentFull}
                /> */}
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  className="box-shadow lj_faq_accordian "
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="lj_faq_Question_heading "
                  >
                    <div>
                      <h2 className="mb-0">
                        Shop Diamond Engagement Rings at Swales Diamonds
                      </h2>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <p className="text-left">
With our unique blend of almost two decades of gemological expertise and a deep passion for crafting bespoke jewellery that resonates with your style, we are excited to bring your vision to life in the form of the most extraordinary  <span style={highlightedStyle}> engagement rings in the UK.</span>
</p>
                      <p className="text-left">
                        At our core, we believe that jewellery is far more than
                        a mere accessory; it reflects your individuality,
                        symbolises love, and is a cherished memento of the most
                        significant moments in your life. Every piece we create
                        is infused with this belief, ensuring that each
                        <span style={highlightedStyle}> engagement ring</span> is not only a stunning work of art but
                        also a deeply personal expression of your unique story.
                        Our commitment to quality and beauty is evident in every
                        piece of jewellery we design because we understand how
                        important an engagement ring is as an investment. To
                        make sure that your diamond ring meets the highest
                        standard possible, we meticulously create each piece,
                        from the initial design to the final polish, to ensure
                        you receive a one-of-a-kind ring that offers exceptional
                        value for your investment.
                      </p>
                      <p className="text-left">
                        Our team boasts extensive experience in gemology and has
                        dedicated years to mastering the intricacies of
                        gemstones. We understand each gem's unique properties,
                        from clarity to colour units. Our collection of
                        <span style={highlightedStyle}> engagement rings for women </span> has been created with
                        different style preferences in mind, and we use the same
                        approach to design your bespoke piece. From the cut,
                        colour, and clarity, we ensure you don't have to settle
                        for anything less than the perfect piece of jewellery.
                      </p>
                      <p className="text-left">Moreover, we pay utmost attention to giving each customer an unforgettable experience when they shop with us. To ensure that you successfully find your dream ring, we guide you through every step of the process with care and attention. We take the time to understand your preferences to help you choose better between an  <span style={highlightedStyle}> oval engagement ring </span>or a round diamond engagement ring. Ultimately, we want your jewellery shopping experience at Swales Diamonds to align with your expectations, and we take all the possible measures to make it a reality. So, no matter how unique and extraordinary your vision for an engagement ring is, we will be honoured to be a part of your journey, and we look forward to creating an engagement ring that justifies your relationship and style.
                      </p>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <h2 className="my-5 my-md-4 my-sm-4 my-xs-4 my-lg-5 text-center text-uppercase"><strong>Learn More About Engagement Rings (FAQ's)</strong></h2>
                {faqData.map((faq) => (
        <Accordion
          key={faq.id}
          expanded={expanded === faq.id}
          onChange={handleChange(faq.id)}
          className="lj_faq_accordian"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${faq.id}-content`}
            id={`${faq.id}-header`}
            className="lj_faq_Question_heading"
          >
            <div>
              <h3 className="text-left">{faq.title}</h3>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="lj_faq_Question_ans">{faq.content}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
              </div>
            </Col>
          </Row>
        </Container>
        {/* Accordian data */}
      </>
      {/*QuickView Modal*/}
    </>
  );
};

export default RingSettings;

// content component
const LongText = ({ getHighlightedDefaultText, fullText }) => {
  const [isExpandedd, setIsExpandedd] = useState(false);
  const toggleText = () => {
    setIsExpandedd(!isExpandedd);
  };

  return (
    <div>
      <p>
        {isExpandedd ? fullText : getHighlightedDefaultText()}
        <span onClick={toggleText}>
          {" "}
          <strong style={{cursor:"pointer"}}>{isExpandedd ? "Read Less" : "Read More"}</strong>
        </span>
      </p>
      {/* <button onClick={toggleText}>
        {isExpanded ? 'Show Less' : 'Show More'}
      </button> */}
    </div>
  );
};
